// src/components/AboutDoctor.jsx
import { FaStethoscope } from "react-icons/fa";

export default function AboutDoctor() {
  return (
    <section className="bg-white py-16 px-6 md:px-12">
      <div className="max-w-4xl mx-auto bg-green-50 p-8 md:p-10 rounded-3xl shadow-xl border border-green-100">
        {/* Title */}
        <div className="flex items-center gap-3 mb-6 text-green-700">
          <FaStethoscope className="text-3xl" />
          <h2 className="text-3xl font-bold">About Dr. Nidhi Malviya</h2>
        </div>

        {/* Credentials */}
        <p className="text-xl font-semibold text-gray-800 mb-2">
          BHMS, CCH, CGO
        </p>
        <p className="text-md italic text-gray-600 mb-6">
          Specialized in a holistic approach to health and wellness
        </p>

        {/* Description */}
        <p className="text-gray-700 leading-relaxed text-lg">
          Dr. Nidhi Malviya offers natural and effective homeopathic treatment at <strong>Aarogyam Homeopathic Clinic</strong>. She is a compassionate and dedicated homeopathy doctor with an outstanding track record of ensuring patient comfort, satisfaction, and well-being. 
          <br /><br />
          With deep knowledge of homeopathic principles and years of experience, she is skilled in accurate diagnosis and delivers personalized care rooted in therapeutic expertise. Her focus is not just on curing symptoms but promoting long-term wellness and holistic healing.
        </p>
      </div>
    </section>
  );
}
